import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
// import { Slider  } from '@mui/joy';

// import Slider, { SliderThumb } from '@mui/material/Slider';
// import { styled } from '@mui/material/styles';
import { Typography, Grid } from '@mui/material';

import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styles from './styles.js';


export default function CategorySlider(props) {
  const { setValue, value, name, color, allowChange, tooltipText } = props;
  const { mainGrid, QuestionMarkers, LabelText, PercentageText, Slider } = styles

  // const PrettoSlider = styled(Slider)({
  //   color: color,
  //   height: 40,
  //   borderRadius: 0,
  //   '& .MuiSlider-track': {
  //     border: 'none',
  //     // color: "green"
  //   },
  //   '& .MuiSlider-thumb': {
  //     height: 44,
  //     width: 20,
  //     borderRadius: 0,
  //     // backgroundColor: '#fff',
  //     border: '2px solid #000',
  //     '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
  //       boxShadow: 'inherit',
  //     },
  //     '&::before': {
  //       display: 'none',
  //     },
  //   },
  //   '& .MuiSlider-valueLabel': {
  //     display: 'none',
  //     // lineHeight: 1.2,
  //     // fontSize: 12,
  //     // background: 'unset',
  //     // padding: 0,
  //     // width: 32,
  //     // height: 32,
  //     // borderRadius: '50% 50% 50% 0',
  //     // backgroundColor: '#52af77',
  //     // transformOrigin: 'bottom left',
  //     // transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
  //     // '&::before': { display: 'none' },
  //     // '&.MuiSlider-valueLabelOpen': {
  //     //   transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
  //     // },
  //     // '& > *': {
  //     //   transform: 'rotate(45deg)',
  //     // },
  //   }, 
  // });

  const handleChange = (event, newValue) => {
    console.log("newValue - value", newValue - value)

    if(allowChange(newValue - value)){
      setValue(newValue);
      console.log("newValue", newValue,value)
    }
    // }else{
    //   alert("Total should be between 0 and 100");
    // }
      // console.log(newValue);
  }

  return (
    <Grid container xs={12} justifyContent={"space-evenly"} alignItems={"center"} style={{ minHeight: 25 }}>
      <Grid xs={4} textAlign={"center"}>
        <LabelText>
          {name}
          <Tooltip title={tooltipText}>
            <IconButton>
              <QuestionMarkers />
            </IconButton>
          </Tooltip>
        </LabelText>
      </Grid>
      <Grid xs={6} style={{ 
        height: 20,
        display: "flex",
    justifyContent: "center",
    alignItems: "center" }}>
      {/* <PrettoSlider
        valueLabelDisplay="auto"
        aria-label="pretto slider"
        value={value}
        // defaultValue={value}
        onChange={(e,value) => setValue(value)}
      /> */}
      {/* "--Slider-markSize": "10px", "--Slider-markSize": "10px", */}
        <Slider
          sx={{ "--Slider-trackBackground": color}}
          min={1}
          max={100}
          color="primary"
          value={value}
          onChange={handleChange}
        />
      </Grid>
      <Grid xs={2} textAlign={"center"}>
        <PercentageText>{value}%</PercentageText>
      </Grid>
    </Grid>
  );
}
